// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter_filterWrapper__te4Lp {
  width: 100%;
  border-radius: 8px;
  padding: 16px 24px;
  background: var(--mui-palette-grey-200);
  box-sizing: border-box;
}

@media only screen and (max-width: 768px) {
  .filter_filterWrapper__te4Lp {
    padding: 12px 16px;
  }
}

.filter_smallFilterWrapper__3pdTI {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: flex-end;
}

@media only screen and (max-width: 768px) {
  .filter_smallFilterWrapper__3pdTI {
    width: 100%;
  }
}

.filter_smallFilterWrapper__3pdTI button {
  width: 140px;
}

@media only screen and (max-width: 768px) {
  .filter_smallFilterWrapper__3pdTI button {
    width: auto;
  }
}

.filter_smallFilterChildrenWrapper__vL9cl {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.filter_iconWrapper__XRNsV {
  background: var(--mui-palette-primary-300);
  border-radius: 6px;
  padding: 5px;
  cursor: pointer;
}

.filter_inputWrapper__WWkxL {
  display: flex;
  flex-direction: column;
}

@media only screen and (max-width: 768px) {
  .filter_inputWrapper__WWkxL {
    flex: 1 1;
  }
}

.filter_inputWrapper__WWkxL input {
  width: 400px;
}

@media only screen and (max-width: 900px) {
  .filter_inputWrapper__WWkxL input {
    width: 350px;
  }
}

@media only screen and (max-width: 768px) {
  .filter_inputWrapper__WWkxL input {
    width: 100%;
  }
}

.filter_advancedFilterWrapper__3dPNE {
  margin-top: 10px;
  max-height: 0;
  transition: max-height 0.15s ease-out;
  overflow: hidden;
}

.filter_advancedFilterWrapperOpen__r2WZ6 {
  margin-top: 10px;
  max-height: 500px;
  transition: max-height 0.25s ease-in;
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui/dist/filter/filter.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,SAAO;EACT;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC","sourcesContent":[".filterWrapper {\n  width: 100%;\n  border-radius: 8px;\n  padding: 16px 24px;\n  background: var(--mui-palette-grey-200);\n  box-sizing: border-box;\n}\n\n@media only screen and (max-width: 768px) {\n  .filterWrapper {\n    padding: 12px 16px;\n  }\n}\n\n.smallFilterWrapper {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: flex-end;\n}\n\n@media only screen and (max-width: 768px) {\n  .smallFilterWrapper {\n    width: 100%;\n  }\n}\n\n.smallFilterWrapper button {\n  width: 140px;\n}\n\n@media only screen and (max-width: 768px) {\n  .smallFilterWrapper button {\n    width: auto;\n  }\n}\n\n.smallFilterChildrenWrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n\n.iconWrapper {\n  background: var(--mui-palette-primary-300);\n  border-radius: 6px;\n  padding: 5px;\n  cursor: pointer;\n}\n\n.inputWrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n@media only screen and (max-width: 768px) {\n  .inputWrapper {\n    flex: 1;\n  }\n}\n\n.inputWrapper input {\n  width: 400px;\n}\n\n@media only screen and (max-width: 900px) {\n  .inputWrapper input {\n    width: 350px;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .inputWrapper input {\n    width: 100%;\n  }\n}\n\n.advancedFilterWrapper {\n  margin-top: 10px;\n  max-height: 0;\n  transition: max-height 0.15s ease-out;\n  overflow: hidden;\n}\n\n.advancedFilterWrapperOpen {\n  margin-top: 10px;\n  max-height: 500px;\n  transition: max-height 0.25s ease-in;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterWrapper": `filter_filterWrapper__te4Lp`,
	"smallFilterWrapper": `filter_smallFilterWrapper__3pdTI`,
	"smallFilterChildrenWrapper": `filter_smallFilterChildrenWrapper__vL9cl`,
	"iconWrapper": `filter_iconWrapper__XRNsV`,
	"inputWrapper": `filter_inputWrapper__WWkxL`,
	"advancedFilterWrapper": `filter_advancedFilterWrapper__3dPNE`,
	"advancedFilterWrapperOpen": `filter_advancedFilterWrapperOpen__r2WZ6`
};
export default ___CSS_LOADER_EXPORT___;
